(function () {
  var SECTIONS = ['products_best_sellers'];
  var PIXELS_PER_SECOND = 30;

  function start(section) {
    var scroller = section.querySelector('slideshow-slides');
    if (!scroller || !scroller.firstElementChild) return;

    scroller.style.scrollSnapType = 'none';

    var paused = false;
    var last = null;

    var gap = function () {
      return parseFloat(getComputedStyle(scroller).columnGap) || 0;
    };

    var pause = function () {
      paused = true;
    };
    var resume = function () {
      paused = false;
      last = null;
    };

    section.addEventListener('pointerenter', pause);
    section.addEventListener('pointerleave', resume);
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', resume);
    scroller.addEventListener('pointerdown', pause);
    document.addEventListener('pointerup', resume);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else resume();
    });

    var step = function (now) {
      requestAnimationFrame(step);
      if (paused) return;

      if (last === null) {
        last = now;
        return;
      }
      var elapsed = Math.min(now - last, 50); // ignore stalls after a tab switch
      last = now;

      scroller.scrollTo({ left: scroller.scrollLeft + (PIXELS_PER_SECOND * elapsed) / 1000, behavior: 'instant' });

      var first = scroller.firstElementChild;
      var width = first.getBoundingClientRect().width + gap();
      if (scroller.scrollLeft >= width) {
        scroller.appendChild(first);
        scroller.scrollTo({ left: scroller.scrollLeft - width, behavior: 'instant' });
      }
    };

    requestAnimationFrame(step);
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    SECTIONS.forEach(function (name) {
      var section = document.querySelector('[id*="' + name + '"]');
      if (section) start(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
